<template>
    <div>
      <div class="basket-product-card basket-combo-card"
           v-if="combo.entity !== undefined && combo.entity === 'combo'">
        <div class="basket-product-card-image" :style="{ backgroundImage: `url(${combo.image})` }"></div>
        <div class="basket-product-card-header">
          <div class="basket-product-card-title basket-combo-card-title" @click="changeCombo(combo)">{{ combo.title }}</div>
          <div class="basket-product-card-description basket-combo-card-description">
            <span v-for="(comboItem, index) in combo.items" :key="comboItem.productId + '-' + index">
              {{ comboItem.productTitle }}
            </span>
          </div>
          <div class="basket-product-card-description">
            <span class="cart-product-card-quantity">x {{ combo.quantity }} {{phrases.PCS}}</span>
          </div>
        </div>
        <div class="basket-product-card-footer">
          <div class="basket-product-card-buttons">
            <div @click="changeComboQuantity(-1, combo.code)" class="button-quantity minus">
              <span class="pp-icon pp-icon-minus"></span>
            </div>
            <div @click="changeComboQuantity(1, combo.code)" class="button-quantity plus">
              <span class="pp-icon pp-icon-plus"></span>
            </div>
          </div>
          <div class="basket-product-card-price">{{ combo.price }}&#8381;</div>
        </div>
      </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ComboUtils from "@/components/combos/ComboUtils.vue";
    import BasketItemUtils from "@/components/basket/BasketItemUtils.vue";

    export default {
        name: "BasketComboItem",
        props: {
            combo: {},
        },
        computed: {
            ...mapGetters('app', {
                phrases: 'getPhrases',
            })
        },
        mixins: [ComboUtils, BasketItemUtils],
    }
</script>

<style scoped lang="scss">
  .basket-combo-card{
    .basket-product-card-image{
      top: 0;
    }
    .basket-combo-card-title{
      cursor: pointer;
    }
    .basket-combo-card-description{
      display: flex;
      flex-direction: column;
      font-family: "Panton", sans-serif;
      span{
        line-height: 1rem;
      }
    }
  }
</style>
